import https from "@/utils/api";
// 获取气候态势
export const getWeatherSituation = () => {
  
  return https.get('screen/overall/weather').then(res=>{
    return res
  })
}
export const getDustSituation = () => {
  
  return https.get('screen/overall/dust').then(res=>{
    return res
  })
}
export const getNoiseSituation = () => {
  
  return https.get('screen/overall/noise').then(res=>{
    return res
  })
}
export const getVideoSituation = () => {
  
  return https.get('screen/overall/video').then(res=>{
    return res
  })
}
export const getAttendanceSituation = () => {
  
  return https.get('screen/overall/staff/attendance').then(res=>{
    return res
  })
}
export const getInspectionData = (type='')=>{ //巡检态势
  return https.get('screen/overall/inspection/info?type='+type).then(res=>{
    return res
  })
}
export const getCarData= ()=>{ //工程车辆
  return https.get('screen/overall/car/info').then(res=>{
    return res
  })
}
export const getLiftingMachineryData= ()=>{ //起重器械
  return https.get('screen/overall/liftingMachinery/info').then(res=>{
    return res
  })
}
export const getMaterialReceiveData= ()=>{ //地磅监控
  return https.get('screen/overall/materialReceive/info').then(res=>{
    return res
  })
}
export const getProjectProgressData= ()=>{ //材料进度
  return https.get('screen/overall/project/progress').then(res=>{
    return res
  })
}
export const getSecurityData= ()=>{ //安全文明情况
  return https.get('screen/overall/security/info').then(res=>{
    return res
  })
}
export const getMateriaAnalysislData= ()=>{ //材料采收态势
  return https.get('screen/overall/material/analysis/info').then(res=>{
    return res
  })
}
export const getRealNameDeviceData= ()=>{ //实名制设备
  return https.get('screen/overall/real_name/device').then(res=>{
    return res
  })
}
